// components/InactivityWarningDialog.tsx
import React from 'react';
import { AlertTriangle, Clock } from 'lucide-react';

interface InactivityWarningDialogProps {
  showInactivityWarning: boolean;
  warningCountdown: number;
  extendSession: () => void;
  handleInactivityLogout: () => void;
}

const InactivityWarningDialog: React.FC<InactivityWarningDialogProps> = ({
  showInactivityWarning,
  warningCountdown,
  extendSession,
  handleInactivityLogout
}) => {
  if (!showInactivityWarning) return null;

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="bg-yellow-50 border-b px-6 py-4 flex items-center space-x-3">
          <AlertTriangle className="text-yellow-600" size={24} />
          <h3 className="text-lg font-semibold text-gray-900">Inaktivitetsvarsel</h3>
        </div>
        
        <div className="p-6">
          <p className="text-gray-700 mb-4">
            Du har vært inaktiv i 55 minutter. Du vil bli automatisk logget ut om:
          </p>
          
          <div className="bg-yellow-100 border border-yellow-300 rounded-lg p-4 text-center mb-6">
            <div className="text-2xl font-bold text-yellow-800 flex items-center justify-center">
              <Clock className="mr-2" size={20} />
              {formatTime(warningCountdown)}
            </div>
            <div className="text-sm text-yellow-700">minutter</div>
          </div>
          
          <p className="text-sm text-gray-600 mb-6">
            Klikk "Fortsett arbeid" for å forlenge økten din.
          </p>
          
          <div className="flex space-x-3">
            <button
              onClick={extendSession}
              className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
            >
              Fortsett arbeid
            </button>
            <button
              onClick={handleInactivityLogout}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
            >
              Logg ut nå
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarningDialog;